// extracted by mini-css-extract-plugin
export default {"mensagem":"IconeMensagem_mensagem__TWKnK"};